export const calculateTranslate = (
  direction: number,
  themeTranslateX: number,
  width: number
): number => {
  const nextPosition = direction * width * themeTranslateX
  if (direction) {
    return nextPosition
  } else {
    return 0
  }
}
